import Constants from 'expo-constants'
import unwrap from 'ts-unwrap'

export const BUGSNAG_API_KEY = unwrap<string>(Constants.expoConfig?.extra?.bugsnag.apiKey)
export const FILE_UPLOAD_ENDPOINT = unwrap<string>(Constants.expoConfig?.extra?.fileUploadEndpoint)
export const GRAPHQL_API_ENDPOINT = unwrap<string>(Constants.expoConfig?.extra?.graphqlApiEndpoint)
export const INTERNAL_VERSION = unwrap<string>(Constants.expoConfig?.extra?.internalVersion)
export const MARKETING_VERSION = unwrap<string>(Constants.expoConfig?.extra?.marketingVersion)
export const LOCO_ORDER_ENDPOINT = unwrap<string>(Constants.expoConfig?.extra?.locoOrderEndpoint)
